export const DEFAULT_ALL = "#0B0F14";

const hexToHsl = (hex) => {
  const n = parseInt(hex.slice(1), 16);
  const [r, g, b] = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map((v) => v / 255);
  const max = Math.max(r, g, b), min = Math.min(r, g, b), l = (max + min) / 2;
  if (max === min) return [0, 0, Math.round(l * 100)];
  const d = max - min;
  const s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
  const h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
  return [Math.round(h * 60), Math.round(s * 100), Math.round(l * 100)];
};

const isLight = (hex) => {
  const n = parseInt(hex.slice(1), 16);
  return 0.299 * ((n >> 16) & 255) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255) > 170;
};

const VARS = ["--shell", "--shell-fg", "--primary", "--primary-foreground", "--ring", "--background", "--accent", "--accent-foreground"];

export const applyTheme = (hex) => {
  const root = document.documentElement.style;
  if (!hex || !/^#[0-9a-fA-F]{6}$/.test(hex)) {
    VARS.forEach((v) => root.removeProperty(v));
    return;
  }
  const [h, s, l] = hexToHsl(hex);
  const light = isLight(hex);
  const fg = light ? "221 39% 11%" : "0 0% 100%";
  const tintS = Math.min(s, 70);
  root.setProperty("--shell", `${h} ${s}% ${l}%`);
  root.setProperty("--shell-fg", fg);
  root.setProperty("--primary", light ? `${h} ${s}% ${Math.min(l, 45)}%` : `${h} ${s}% ${l}%`);
  root.setProperty("--primary-foreground", "0 0% 100%");
  root.setProperty("--ring", `${h} ${s}% ${Math.min(l, 45)}%`);
  root.setProperty("--background", `${h} ${tintS}% ${s < 15 ? 95 : 96}%`);
  root.setProperty("--accent", `${h} ${tintS}% 92%`);
  root.setProperty("--accent-foreground", `${h} ${s}% ${Math.min(l, 30)}%`);
};
